module.exports = __webpack_public_path__ + "dollar-slash.7a80cc4374d7d0d534d7c313cb875b91.svg";